const initialState = {
    meters: undefined,
    loading: false,
    error: false
};

export default initialState;
